<div [chart]="chart"></div>
